import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/components/HomeOne/DiscountOfferTrip.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/components/HomeOne/HeroBanner/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/components/HomeOne/OurHottestVideos.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/components/HomeOne/WhyChooseUs.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/components/Layout/Footer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/components/Layout/Navbar.tsx");
